import { ENDPOINTS } from '../_config';

export const getUserIndustries = async () => {
  try {
    const request = await fetch(ENDPOINTS.GET_USER_INDUSTRIES);
    const response = await request.json();

    return response.Industries;
  } catch (e) {
    return null;
  }
};
